import React from 'react';
import {
  Container, Grid, Card, Header, Text,
} from 'tabler-react';
import { Link } from '@curi/react-dom';

const webpackRequireContext = require.context('!markdown-with-front-matter-loader!../_posts', false, /.md$/);
const blogs = webpackRequireContext.keys().reduce((memo, fileName) => memo.set(fileName.match(/.\/([^.]+).*/)[1], webpackRequireContext(fileName)), new Map());


const blogWrapper = ({ __content }) => () => (
  <Container>
    <Grid.Row className="my-3">
      <Grid.Col lg={8} sm={12} className="mx-auto">
        <Card>
          <Card.Body>
            <Link name="Updates">« Back</Link>
            <hr />
            <div className="markdown-body" dangerouslySetInnerHTML={{ __html: __content }} />
          </Card.Body>
        </Card>
      </Grid.Col>
    </Grid.Row>
  </Container>
);

const BlogPreview = ({
  title, summary, path, date,
}) => (
  <Card className="my-1">
    <Card.Body>
      <Header.H4>
        <Link name={path}>{title}</Link>
      </Header.H4>
      <Text>{summary}</Text>
      <Text.Small>{date}</Text.Small>
    </Card.Body>
  </Card>
);

const blogIndex = blogs => () => (
  <Container>
    <Grid.Row className="my-3">
      <Grid.Col lg={8} sm={12} className="mx-auto">
        {[...blogs.keys()].map(path => <BlogPreview path={path} title={blogs.get(path).title || path} summary={blogs.get(path).summary || ''} date={blogs.get(path).published_on || ''} />)}
      </Grid.Col>
    </Grid.Row>
  </Container>
);

const Blogs = blogIndex(blogs);

const posts = [...blogs
  .keys()]
  .map(path => ({
    name: path,
    path: `updates/${path}`,
    response: () => ({ body: blogWrapper(blogs.get(path)) }),
  }));

const blogRoutes = [
  { name: 'Updates', path: 'updates', response: () => ({ body: Blogs }) },
  ...posts,
];

export default blogRoutes;



// WEBPACK FOOTER //
// ./src/blogs/index.js